import { StyleSheet } from 'react-native';
import { color, palette, spacing, typography } from '../../theme';

export const styles = StyleSheet.create({
  buttons: {
    flexDirection: 'row',
  },
  checkList: {
    flex: 1,
    width: undefined,
  },
  checkbox: {
    alignItems: 'center',
  },
  checkboxStar: {
    marginLeft: 0,
  },
  columnCenter: {
    flex: 1,
    marginHorizontal: 24,
  },
  container: {
    flexDirection: 'row',
  },
  dateBox: {
    marginRight: 16,
  },
  header: {
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
  headerActionButton: {
    marginLeft: 16,
  },
  headerIconButton: {
    borderRadius: 28,
    height: 56,
    marginRight: 24,
    width: 56,
  },
  headerInput: {
    borderBottomWidth: 2,
    borderRadius: 0,
    borderWidth: 0,
    color: color.text,
    flex: 1,
    fontFamily: typography.primary.bold,
    fontSize: 24,
    height: 56,
    paddingLeft: spacing[4],
    paddingRight: spacing[4],
    width: '100%',
  },
  horizontalContainer: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    paddingVertical: 16,
    width: '100%',
  },
  iconColumn: {
    width: 77,
  },
  icons: {
    color: palette.Dark_blue,
  },
  inputsColumn: {
    alignItems: 'center',
    flexDirection: 'row',
    flex: 1,
  },
  parent: {
    padding: 16,
    backgroundColor: palette.white,
  },
  text: {
    fontWeight: 'bold',
    marginRight: 16,
  },
  textInput1: {
    alignSelf: 'stretch',
    flex: 1,
    width: undefined,
    minWidth: 50,
  },
  timeBox: {
    marginRight: 16,
  },
  textInputWithButtonsContainer: {
    overflow: 'hidden',
  },
  textInputWithButtonsText: {
    width: 0,
  },
  scroller: {
    paddingHorizontal: 20,
    paddingBottom: 100,
    gap: 20,
  },
  largeInput: {
    width: '100%',
  },
});
